// Components==============
import AddInput from 'components/UI/AddInput/AddInput';
import LessonCard from 'components/UI/LessonCard/LessonCard';
import SessionCard from 'components/UI/SessionCard/SessionCard';
import { motion } from 'framer-motion';
import { useTranslate } from 'hooks/useTranslate';
import React, { useContext } from 'react';
import { TrainingBuilderContext } from '../../TrainingBuilder';
import LessonEditCard from './LessonEditCard/LessonCard';
import SessionEditCard from './SessionEditCard/SessionCard';
import './SessionEditor.module.scss';
// =========================

export default function SessionEditor() {
  const {
    currentSession,
    trainingSessions,
    handleAddLesson,
    sessions,
    training,
    editorView,
  } = useContext(TrainingBuilderContext);

  const translate = useTranslate();

  const lessons = sessions.find((s) => s.id === currentSession)?.lessons;

  return (
    <motion.div
      exit={{ opacity: 0, display: 'none' }}
      initial={{ opacity: 0, display: 'none' }}
      animate={
        editorView === 'session'
          ? { opacity: 1, display: 'block' }
          : { opacity: 0, display: 'none' }
      }
    >
      <div styleName="wrapper">
        {sessions.find((s) => s.id === currentSession)?.is_published ? (
          <SessionCard
            session={trainingSessions?.find((s) => s?.id === currentSession)}
            sessionId={currentSession}
            training={training}
            locked
          />
        ) : (
          <SessionEditCard />
        )}
        {lessons
          ?.sort((a, b) => a?.order_index - b?.order_index)
          ?.map((lesson, index) =>
            lesson.is_published ? (
              <LessonCard
                lesson={
                  trainingSessions
                    ?.find((s) => s?.id === currentSession)
                    ?.lessons?.find((l) => l.id === lesson.id)!
                }
                index={index + 1}
                key={lesson.id}
                locked
              />
            ) : (
              <LessonEditCard
                lesson={lesson}
                index={index + 1}
                key={lesson.id}
              />
            )
          )}

        <div styleName="add-lesson">
          <p>{translate('course.terms.add-lesson')}</p>
          <AddInput
            onSubmit={(val) => handleAddLesson(val)}
            placeholder={`${translate('course.terms.lesson')}...`}
          />
        </div>
      </div>
    </motion.div>
  );
}
